import { DataStore } from "aws-amplify";

export const clearDataStore = () => DataStore.clear();